import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

export function BottomSheet({
  open,
  onOpenChange,
  headerContent,
  children,
  footerContent,
  panelClassName = "max-w-md",
  isDesktop = false,
  isFirmaManuscrita = false,
  variant = "dark",
}) {
  const isLight = variant === "light";

  return (
    <Dialog open={open} onClose={onOpenChange} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed bottom-0 inset-0 bg-darkBgLight/75 transition-opacity duration-500 ease-linear data-closed:opacity-0"
        style={{ backgroundColor: isLight ? "#00000080" : "#00000033" }}
      />

      {/* Estructura idéntica al componente de opciones */}
      <div className="fixed inset-x-0">
        <div className="absolute inset-0">
          <div
            className="pointer-events-none fixed bottom-0 flex w-screen"
            style={{
              insetInline: 0,
              justifyContent: isDesktop ? "flex-end" : "center",
              height: isDesktop ? "100%" : "auto",
            }}
          >
            <DialogPanel
              transition
              className={`pointer-events-auto w-full ${panelClassName} transition duration-500 ease-in-out sm:duration-700
                ${
                  isDesktop
                    ? "data-closed:translate-x-full"
                    : "data-closed:translate-y-full"
                }`}
              style={{ height: isDesktop ? "100%" : "auto" }}
            >
              <div
                className="flex flex-col rounded-t-3xl shadow-lg overflow-hidden"
                style={{
                  backgroundColor: isLight ? "#fff" : "#565584",
                  height: isDesktop ? "100%" : "auto",
                  borderRadius: isDesktop ? "0px" : undefined,
                  justifyContent: isDesktop ? "space-between" : undefined,
                }}
              >
                {/* --- HEADER --- */}
                <div
                  className="relative px-5 py-5 flex justify-between items-center"
                  style={{
                    backgroundColor: isLight ? "#fff" : "#565584",
                    color: isLight ? "#565584" : "#FAFAFA",
                  }}
                >
                  <div className="flex-1">{headerContent}</div>
                  <button
                    onClick={() => onOpenChange(false)}
                    className={`ml-3 ${isLight ? "text-grayP" : "text-white"} hover:text-grayP focus:outline-hidden`}
                    style={{cursor: "pointer"}}
                  >
                    <XMarkIcon className="w-6 h-6" />
                  </button>
                </div>

                {/* --- BODY --- */}
                <div
                  className="flex-1 max-h-[70vh] mb-0 overflow-auto px-5 py-4 text-sm text-grayP scroll-box"
                  style={{
                    borderTopLeftRadius: "50px",
                    borderTopRightRadius: "50px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    backgroundColor: isLight ? "#fff" : "#1C1535",
                    color: isLight ? "#1C1535" : undefined,
                    maxHeight: isDesktop ? "100%" : undefined,
                    justifyContent: isFirmaManuscrita ? "center" : undefined,
                    borderTopLeftRadius: isLight ? 0 : "50px",
                    borderTopRightRadius: isLight ? 0 : "50px",
                  }}
                >
                  {children}
                </div>

                {/* --- FOOTER --- */}
                {footerContent && (
                  <div
                    className="px-5 py-3"
                    style={{ backgroundColor: isLight ? "#fff" : "#1C1535" }}
                  >
                    {footerContent}
                  </div>
                )}
              </div>
            </DialogPanel>
          </div>
        </div>
      </div>

      <style>{`
        .scroll-box::-webkit-scrollbar { width: 10px; }
        .scroll-box::-webkit-scrollbar-track {
          background: transparent;
          border-radius: 10px;
          margin-top: 25px;
        }
        .scroll-box::-webkit-scrollbar-thumb {
          background: #E1DFE5;
          border-radius: 10px;
        }
      `}</style>
    </Dialog>
  );
}
